import { default as achievementsRFnKCvglPaMeta } from "/opt/build/repo/pages/achievements.vue?macro=true";
import { default as indexB62jxBr09WMeta } from "/opt/build/repo/pages/buy-ticket/index.vue?macro=true";
import { default as successr248Pjz3JpMeta } from "/opt/build/repo/pages/buy-ticket/success.vue?macro=true";
import { default as homeZXalWvqDQEMeta } from "/opt/build/repo/pages/home.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as photosgH8CimWt40Meta } from "/opt/build/repo/pages/photos.vue?macro=true";
import { default as profileNJNbyWXx9rMeta } from "/opt/build/repo/pages/profile.vue?macro=true";
import { default as redemptionsvgZD9thZWOMeta } from "/opt/build/repo/pages/redemptions.vue?macro=true";
import { default as completefyiCc6qBdlMeta } from "/opt/build/repo/pages/setup-profile/complete.vue?macro=true";
import { default as index3yjI8KhmTvMeta } from "/opt/build/repo/pages/setup-profile/index.vue?macro=true";
export default [
  {
    name: "achievements",
    path: "/achievements",
    component: () => import("/opt/build/repo/pages/achievements.vue").then(m => m.default || m)
  },
  {
    name: "buy-ticket",
    path: "/buy-ticket",
    component: () => import("/opt/build/repo/pages/buy-ticket/index.vue").then(m => m.default || m)
  },
  {
    name: "buy-ticket-success",
    path: "/buy-ticket/success",
    component: () => import("/opt/build/repo/pages/buy-ticket/success.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/opt/build/repo/pages/home.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "photos",
    path: "/photos",
    component: () => import("/opt/build/repo/pages/photos.vue").then(m => m.default || m)
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/opt/build/repo/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: "redemptions",
    path: "/redemptions",
    component: () => import("/opt/build/repo/pages/redemptions.vue").then(m => m.default || m)
  },
  {
    name: "setup-profile-complete",
    path: "/setup-profile/complete",
    component: () => import("/opt/build/repo/pages/setup-profile/complete.vue").then(m => m.default || m)
  },
  {
    name: "setup-profile",
    path: "/setup-profile",
    component: () => import("/opt/build/repo/pages/setup-profile/index.vue").then(m => m.default || m)
  }
]